
import PricingButton from "@/components/main/pricing/PricingButton";
import RedHeadBox from "@/components/main/core/RedHeadBox";
import SearchCircle from "@/components/main/core/SearchCircle"

import face from "@/assets/images/main/example/social/face.png"
import flickr from "@/assets/images/main/example/social/flickr.png"
import flirt from "@/assets/images/main/example/social/flirt.png"
import luxy from "@/assets/images/main/example/social/luxy.png"
import moco from "@/assets/images/main/example/social/moco.png"
import okupid from "@/assets/images/main/example/social/okupid.png"
import snap from "@/assets/images/main/example/social/snap.png"
import tumblr from "@/assets/images/main/example/social/tumblr.png"
import twitter from "@/assets/images/main/example/social/twitter.png"
import twoo from "@/assets/images/main/example/social/twoo.png"

import isMobile from "@/mixins/isMob";

import data from "@/mixins/data";
import gsap from "gsap";
export default {
  name: "SocialTab",
  components: { PricingButton, RedHeadBox, SearchCircle, isMobile},
  mixins: [data, isMobile],
  data() {
    return {
      date: new Date(),
      complete: false,
      socialServices: [
        {
          logo: face,
          isFound: true,
          email: 'name@email.com',
          service: 'facebook.com'
        },
        {
          logo: flickr,
          isFound: false,
          email: '',
          service: 'flickr.com'
        },
        {
          logo: flirt,
          isFound: true,
          email: 'name@email.com',
          service: 'flirt.com'
        },
        {
          logo: luxy,
          isFound: false,
          email: '',
          service: 'luxy.com'
        },
        {
          logo: moco,
          isFound: true,
          email: 'name@email.com',
          service: 'moco.com'
        },
        {
          logo: okupid,
          isFound: true,
          email: 'name@email.com',
          service: 'okupid.com'
        },
        {
          logo: snap,
          isFound: false,
          email: '',
          service: 'snapchat.com'
        },
        {
          logo: tumblr,
          isFound: true,
          email: 'name@email.com',
          service: 'tumblr.com'
        },
        {
          logo: twitter,
          isFound: false,
          email: '',
          service: 'twitter.com'
        },
        {
          logo: twoo,
          isFound: true,
          email: 'name@email.com',
          service: 'twoo.com'
        },
      ]
    }
  },
  methods: {
    datenow() {
      if (this.date.getMinutes())
        return `${this.date.getDate()}/${this.date.getMonth()+1}/${this.date.getFullYear()} ${this.date.getHours()}:${+this.date.getMinutes() <= 10 ? '0'+this.date.getMinutes() : this.date.getMinutes()}`
    },

    beforeEnter(el) {
      el.style.opacity = 0
      el.style.transform = 'translateY(60px)'
    },

    enter(el) {
      gsap.to(el, {
        opacity: 1,
        y: 0,
        duration: 1,
        delay: el.dataset.index*0.6
      })
    },

    end(is) {
      this.complete = is;
    }
  }

}
